import {isEmpty} from 'lodash'
import get from 'lodash/fp/get'
import * as Moment from 'moment'
import * as ReportUtils from '../utils'
import * as Constants from './constants'
import * as Types from './types'

const dropDownDateSelector = (dateValue: Types.DateValue) => {
  switch (dateValue) {
    case Constants.DATE_SELECT_YESTERDAY_MODE:
        return Moment().subtract(1, 'day').format('YYYY-MM-DD');
    case Constants.DATE_SELECT_LASTWEEK_MODE:
        return Moment().subtract(1, 'week').format('YYYY-MM-DD');
    case Constants.DATE_SELECT_TODAY_MODE:
        return Moment().format('YYYY-MM-DD');
    default:
      return null;
  }
}

export const convertSelectedDateToDateString = (dateSelect: Types.DateSelect,
                                                selectedDate: Types.SelectedDate): string => {
  const d = dropDownDateSelector(dateSelect)
  if (!isEmpty(d)) {
    return d
   } else if (isEmpty(selectedDate)) {
    return Moment().format('YYYY-MM-DD')
   } else {
    return Moment(selectedDate).format('YYYY-MM-DD')
   }
}

const safeMoment = (s: string): Moment.Moment => s ? Moment(s) : null

export const toIssue = (payload: any): Types.Issue => {
  return {
    counts: {
      bounced: payload.HardBounce + payload.Dropped,
      delivered: payload.Delivered + payload.Sent,
      expected: payload.expected,
      failed: payload.Failed,
      notGenerated: payload.NotGenerated,
      pending: payload.Pending,
      softBounce: payload.SoftBounce,
      spamReport: payload.SpamReport,
    },
    cutoff: safeMoment(payload.cutoff),
    firstCreated: safeMoment(payload.first_created),
    id: payload.issue_id,
    lastUpdated: safeMoment(payload.last_updated),
    schedule: payload.schedule_name,
    sendAt: safeMoment(payload.send_at),
    stats: {
      sends: payload.num_sent,
    },
    status: payload.status,
    subscribed: payload.Subscribed,
    unsubscribed: payload.Unsubscribed,
  }
}

export const toSubjectLine = (payload: any): Types.SubjectLine => {
  return {
    openRate: payload.open_rate * 100,
    opens: payload.opens,
    sendRate: payload.send_rate * 100,
    sends: payload.sends,
    text: payload.text,
  }
}

const getAggregations = (payload: any, bucketName: string) => get(`aggregations.${bucketName}`, payload)

export const parseSummaryStats = (payload: any): Types.ActionCounts => {

  const eventNameBuckets = getAggregations(payload, 'event_name')
  const clicks = ReportUtils.firstBucketEntry(eventNameBuckets, Constants.CLICK_EVENT) || {}
  const opens = ReportUtils.firstBucketEntry(eventNameBuckets, Constants.OPEN_EVENT) || {}
  return {
    clicks: {
      total: clicks.doc_count || 0,
      unique: (get('unique_count', clicks) || {}).value || 0,
    },
    opens: {
      total: opens.doc_count || 0,
      unique: (get('unique_count', opens) || {}).value || 0,
    },
  }
}

const toHourlyAction = (payload: any): Types.HourlyActionCounts => {
  const clicks = ReportUtils.firstBucketEntry(payload.event_name, Constants.CLICK_EVENT) || {}
  const opens = ReportUtils.firstBucketEntry(payload.event_name, Constants.OPEN_EVENT) || {}
  return {
    clicks: {
      total: clicks.doc_count,
      unique: (get('unique_count', clicks) || {}).value || 0,
    },
    hour: Moment(payload.key_as_string).hour(),
    opens: {
      total: opens.doc_count,
      unique: (get('unique_count', opens) || {}).value || 0,
    },
  }
}

export const parseHourlyActions = (payload: any): Types.HourlyActionCounts[] => {
  const hourly = getAggregations(payload, Constants.HOURLY_COUNT)
  return hourly.buckets.slice(0, 24).map((b: any) => toHourlyAction(b) )
}

export const parseActions = (payload: any): Types.Action[] => payload.results.map((p: {}) => toAction(p))

export const toAction = (payload: any): Types.Action => {
  return {
    created: safeMoment(payload.created),
    description: payload.event_name === Constants.OPEN_EVENT
      ? payload.email_subject
      : `${payload.site_name || payload.source_name}: ${payload.title}`,
    id: payload.id,
    type: payload.event_name,
    url: payload.clicked_url,
    useragent: payload.useragent,
  }
}

export const rate = (numerator: number, denominator: number): string => {
  return `${(denominator > 0 ? 100 * (numerator / denominator) : 0).toFixed(2)}%`
}



// WEBPACK FOOTER //
// ./src/pages/reports/today/utils.ts